import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, empty } from 'rxjs';
import { ConfigService } from './config.service';
import { ApiService } from './api.service';
import { ICategoryBody, IProductTypeBody, ISubmittalPackageDetail, IDownloadSubmittal, ITestReportData, BaseResponse } from '../models';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SubmittalPackageService {

  constructor(private httpClient: HttpClient) { }
  public getArchitecturalDetails(): Observable<Array<ISubmittalPackageDetail>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.SUBMITTALPACKAGE.GET_ARCHITECTURE_DETAILS}`;
    return ApiService.genericObservableGet(this.httpClient, apiEndpoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  
  public getTestReportData(body: Array<IProductTypeBody>): Observable<Array<ITestReportData>> {
    const endPoint = `${ConfigService.APIs.endPoints.SUBMITTALPACKAGE.GET_REPORT_ALL_DATA}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public downloadSubmittal(body: IDownloadSubmittal): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.SUBMITTALPACKAGE.DOWNLOAD_SUBMITTAL}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
}
